import axios from "axios";
import {
  GET_PROCESSES,
  PROCESSES_LOADING,
  GET_CONTRIBUTORS,
  DISPLAY_ERROR,
  HIDE_ERROR,
  EXTEND_LIST,
  SET_SEARCH_TERM,
  SET_SEARCH_MODE,
  SET_FILTER_YEAR
} from "./types";

export const getProcesses = () => dispatch => {
  dispatch(setProcessesLoading());
  var url = new URL(window.location.href);
  axios.get("/alddatabase/api/processes.php"+url.search).then(res => {
    if (!res.data.success) {
      dispatch(displayError(res.data.reason));
      return;
    }

    dispatch({ type: GET_PROCESSES, payload: res.data });
  });
};

export const addProcess = process => dispatch => {
  const params = new URLSearchParams();
  for (let property in process) {
    params.append(property, process[property]);
  }

  axios.post("/alddatabase/api/processes.php", params).then(res => {
    if (!res.data.success) {
      dispatch(displayError(res.data.reason));
      return;
    }

    dispatch(
      displayError(
        "Process submitted successfully, it will be added to the database after it has been checked manually."
      )
    );
  });
};

export const getMetadata = doi => {
  return axios
    .get(`https://api.crossref.org/works/${doi}?mailto=j.w.buiter@tue.nl`)
    .then(res => {
      const data = res.data.message;

      [0, 1, 2].forEach(index => {
        if (!data.issued["date-parts"][0][index])
          data.issued["date-parts"][0][index] = 1;
      });
      const createdDate = data.issued["date-parts"][0].join("-");
      const author = data.author[0].family;
      const numCited = data["is-referenced-by-count"];

      return { createdDate, author, numCited };
    })
    .catch(err => null);
};

export const getContributors = () => dispatch => {
  axios.get("/alddatabase/api/contributors.php").then(res => {
    if (!res.data.success) {
      dispatch(displayError(res.data.reason));
      return;
    }

    dispatch({ type: GET_CONTRIBUTORS, payload: res.data.contributors });
  });
};

export const setProcessesLoading = () => {
  return { type: PROCESSES_LOADING };
};

export const addReference = (process, reference) => dispatch => {
  const params = new URLSearchParams();

  params.append("id", process.id);

  for (let property in reference) {
    params.append(property, reference[property]);
  }

  axios.post("/alddatabase/api/references.php", params).then(res => {
    if (!res.data.success) {
      dispatch(displayError(res.data.reason));
      return;
    }

    dispatch(
      displayError(
        "Reference submitted successfully, it will be added to the database after it has been checked manually."
      )
    );
  });
};

export const addComment = ({ comment, name }) => dispatch => {
  const params = new URLSearchParams();

  params.append("comment", comment);
  params.append("name", name);

  axios.post("/alddatabase/api/comments.php", params).then(res => {
    if (!res.data.success) {
      dispatch(displayError(res.data.reason));
      return;
    }

    dispatch(displayError("Comment submitted successfully."));
  });
};

export const displayError = error => dispatch => {
  dispatch({ type: DISPLAY_ERROR, payload: error });
};

export const hideError = () => dispatch => {
  dispatch({ type: HIDE_ERROR });
};

export const extendList = () => dispatch => {
  dispatch({ type: EXTEND_LIST });
};

export const setSearchTerm = term => dispatch => {
  dispatch({ type: SET_SEARCH_TERM, payload: term });
};

export const setSearchMode = mode => dispatch => {
  dispatch({ type: SET_SEARCH_MODE, payload: mode });
};

export const setFilterYear = year => dispatch => {
  dispatch({ type: SET_FILTER_YEAR, payload: year });
};
